export function QueryStringDataModel() {
    this.appId = null;
    this.appName = null;
    this.apiPrefix = null;
    this.campaignId = null;
    this.walletCardId = null;
    this.contact_number = null;
    this.historyUrl = null;
    this.locale = null;
    this.otp = null;
    this.refcode = null;
    this.returnUrl = null;
    this.theme = null;
    this.token = null;
    this.wallet_token = null;
    this.withholdingtax_key = null;
    this.shoppingCartUrl = null;
    this.shoppingCartApi = null;
    this.loginName = null;
    this.partial_points = null;
    this.partial_baht = null;
    this.is_test = null;
    this.target_page = null;
    this.categoryId = null;
    this.agencyId = null;
}
